import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'About ShipSticks | The Best Way to Ship Golf Clubs',
  description:
    'All about ShipSticks - the best way to ship golf clubs to the course and back again.',
  alternates: {
    canonical: 'https://www.shipsticks.com/about',
  },
}

export default metadata
